import React from "react";
import { useDispatchWrapper } from "./useDispatch";

import { fetchQuotedefaultCoverageList, fetchQuotedefaultRemarksList } from "../redux/QuoteSettings/quoteSettingsActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../redux/initialStoreState";
import { LoadState } from "../constants/enums";

export const useDefaultQuote = () => {
  const {coverageList, loading} = useSelector(
    (state: IStoreState) => state.quoteConfig.defaultCoverage
  );
  const dispatch = useDispatchWrapper();

  const fetchDefaultCoverageByCode = async (defaultCoverageCode: string) => {
    const data = coverageList.find(x=>x.default_coverage_code === defaultCoverageCode);
    if(data){
      return data;
    }
  };

    React.useEffect(() => {
      dispatch(fetchQuotedefaultCoverageList());
    }, []);
 

  return {
    coverageList,
    fetchDefaultCoverageByCode,
    coverageLoading: loading === LoadState.InProgress,
    
  };
};

export const useDefaultRemarks = () => {
  const {remarksList, loading} = useSelector(
    (state: IStoreState) => state.quoteConfig.defaultRemarks
  );
  const dispatch = useDispatchWrapper();

  const fetchDefaultRemarksByCode = async (defaultRemarkCode: string) => {
    const data = remarksList.find(x=>x.remarks_template_code === defaultRemarkCode);
    console.log("data", data);
    if(data){
      return data;
    }
  };

    React.useEffect(() => {
      dispatch(fetchQuotedefaultRemarksList());
    }, []);
 

  return {
    remarksList,
    fetchDefaultRemarksByCode,
    remarksLoading: loading === LoadState.InProgress,
    
  };
};
